<template>
  <div class="header">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 title sr_prevent_flickering"
          v-scrollreveal
        >
          <h1>Case Studies</h1>
          <h4>
            Check out these crypto investigations where Bubblemaps made a
            difference.
          </h4>
        </div>
      </div>
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <wistia-player
            media-id="uxr1on7txj"
            seo="false"
            class="video-player"
            aspect="1.7777777777777777"
          ></wistia-player>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 cbsnews-logo"
        >
          <img src="@/assets/logos/medias/cbsnews.png" alt="CBS News logo" />
        </div>
      </div>
    </div>
  </div>
  <div class="casestudies">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner casestudies__studies">
        <Hawk />
        <Libra />
        <Wolf />
        <Melania />
        <Trump />
        <Yzy />
      </div>
    </div>
  </div>
  <!-- <div class="morestudies">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner morestudies__title">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <h2>More Case Studies</h2>
        </div>
      </div>
      <div class="mdc-layout-grid__inner morestudies__studies">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
          <a
            class="morestudies__thumbnail"
            href="https://twitter.com/bubblemaps/status/1714672882511712755"
            target="_blank"
          >
            <div class="morestudies__logo-container">
              <img src="@/assets/logos_white/dydx.png" alt="dYdX logo" />
            </div>
            <h3>dYdX</h3>
          </a>
        </div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
          <a
            class="morestudies__thumbnail"
            href="https://twitter.com/bubblemaps/status/1684610663090724864"
            target="_blank"
          >
            <div class="morestudies__logo-container">
              <img src="@/assets/logos_white/unibot.png" alt="Unibot logo" />
            </div>
            <h3>Unibot</h3>
          </a>
        </div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
          <a
            class="morestudies__thumbnail"
            href="https://twitter.com/bubblemaps/status/1704888268037505412"
            target="_blank"
          >
            <div class="morestudies__logo-container">
              <img src="@/assets/logos_white/gala.png" alt="GALA logo" />
            </div>
            <h3>GALA</h3>
          </a>
        </div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
          <a
            class="morestudies__thumbnail"
            href="https://twitter.com/bubblemaps/status/1723053393210744863"
            target="_blank"
          >
            <div class="morestudies__logo-container">
              <img src="@/assets/logos_white/grok.png" alt="GROK logo" />
            </div>
            <h3>GROK</h3>
          </a>
        </div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
          <a
            class="morestudies__thumbnail"
            href="https://twitter.com/bubblemaps/status/1655256269660225536"
            target="_blank"
          >
            <div class="morestudies__logo-container">
              <img src="@/assets/logos_white/pepe.png" alt="PEPE logo" />
            </div>
            <h3>PEPE</h3>
          </a>
        </div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
          <a
            class="morestudies__thumbnail"
            href="https://twitter.com/bubblemaps/status/1615032502753853441"
            target="_blank"
          >
            <div class="morestudies__logo-container">
              <img src="@/assets/logos_white/chiliz.png" alt="chiliz logo" />
            </div>
            <h3>chiliz</h3>
          </a>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import Hawk from "@/components/organisms/CaseStudies/studies/Hawk.vue";
import Libra from "@/components/organisms/CaseStudies/studies/Libra.vue";
import Wolf from "@/components/organisms/CaseStudies/studies/Wolf.vue";
import Melania from "@/components/organisms/CaseStudies/studies/Melania.vue";
import Trump from "@/components/organisms/CaseStudies/studies/Trump.vue";
import Yzy from "@/components/organisms/CaseStudies/studies/Yzy.vue";

export default {
  name: "CaseStudies",
  components: {
    Hawk,
    Libra,
    Wolf,
    Melania,
    Trump,
    Yzy,
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/variables";

.header {
  @include theme-almost-black-gradient(45deg);
  margin-top: -56px;
  padding-top: 56px;
}

wistia-player[media-id="uxr1on7txj"]:not(:defined) {
  background: center / contain no-repeat
    url("https://fast.wistia.com/embed/medias/uxr1on7txj/swatch");
  display: block;
  filter: blur(5px);
  padding-top: 56.25%;
}

.video-player {
  max-width: 800px;
  margin: auto;
}

.cbsnews-logo {
  display: flex;

  img {
    max-width: 150px;
    margin: auto;
    margin-bottom: 50px;
  }
}

@media (min-width: $mdc-tablet) {
  .header {
    margin-top: -64px;
    padding-top: 64px;
  }
}

.title {
  text-align: center;
  padding-top: 70px;
  padding-bottom: 70px;

  h1 {
    margin-top: 0;
    margin-bottom: 1rem;
    @include scaling-title(2.1rem, 400px, 200px);
  }
}

@media (max-width: $mdc-tablet) {
  .title {
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .cbsnews-logo {
    img {
      max-width: 100px;
    }
  }
}

.casestudies {
  padding-top: 50px;
  padding-bottom: 50px;
  position: relative;

  // This is for blurring the background image
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("../assets/backgrounds/light.png") no-repeat center,
      url("../assets/backgrounds/light-lqip.png") no-repeat center, #a20142;
    background-size: cover;
    filter: blur(10px);
    z-index: -1;
  }
}

.morestudies {
  padding-top: 50px;
  padding-bottom: 50px;
  background: url("../assets/backgrounds/blur.png") no-repeat center;
  background-size: cover;

  .morestudies__title {
    text-align: center;
  }

  .morestudies__studies {
    max-width: 1100px;
    margin: auto;
  }

  .morestudies__thumbnail {
    @include theme-glass-effect;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    img {
      height: 75px;
      z-index: 2;
      position: relative;
    }

    h3 {
      margin-bottom: 0;
      margin-top: 15px;
      font-size: 1.5rem;
      font-weight: 300;
      letter-spacing: 0.2rem;
    }

    .morestudies__logo-container {
      padding: 15px 0;
      width: 120px;
      text-align: center;
      position: relative;
      transition: transform 200ms ease-in-out;
    }

    .morestudies__logo-container:before {
      @include theme-blue-gradient(45deg);
      content: "";
      opacity: 0;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      border-radius: 15px;
      /* TRANSISITION */
      transition: opacity 200ms ease-in-out;
      -webkit-transition: opacity 200ms ease-in-out;
      -moz-transition: opacity 200ms ease-in-out;
      -o-transition: opacity 200ms ease-in-out;
    }

    &:hover {
      .morestudies__logo-container:before {
        opacity: 1;
      }
      .morestudies__logo-container {
        transform: translateY(-10px);
      }
    }
  }
}
</style>
